import Store from '@/store';
import SisDkpClienteTokenClient from '@/api/sis-dkp-cliente-token.client';
import Notifier from '@/libs/Notifier';

export default class SisDkpClienteTokensService {
  constructor() {
    this.client = new SisDkpClienteTokenClient();
    this.store = Store;
    this.notify = new Notifier();
  }

  async findAll() {
    try {
      const { data, ...pagination } = await this.client.getDkpClientesTokens(this.store.getters['sisDkpClientesTokens/GET_FILTERS']);
      this.store.commit('sisDkpClientesTokens/SET_DKP_CLIENTES_TOKENS_ALL', data);
      this.store.commit('sisDkpClientesTokens/SET_FILTERS', pagination);
    } catch (error) {
      throw this.notify.error(error.message);
    }
  }

  async create(body) {
    try {
      await this.client.postDkpClientesToken(body);
      this.notify.success('Cliente criado com sucesso');
    } catch (error) {
      throw this.notify.error(error.message);
    }
  }

  async delete(id) {
    try {
      await this.client.deleteDkpClientesTokenIdSoftDelete(id);
      this.notify.success('Cliente deletado com sucesso');
    } catch (error) {
      throw this.notify.error(error.message);
    }
  }

  async edit(id, body) {
    try {
      const { message } = await this.client.putDkpClientesTokenId(id, body);
      this.notify.success(message);
    } catch (error) {
      throw this.notify.error(error.message);
    }
  }
}
